export default {
  restoreStateFromLocalStorage(state) {
    // console.log('[init] restore state from local storage');
    // Check if the ID exists
    if (localStorage.getItem("vuex3")) {
      // Replace the state object with the stored item
      try {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem("vuex3")))
        );
      } catch (error) {
        console.error(error);
      }
    }
  },

  pushTemporaryOrders(state, payload) {
    state.placedOrder.push(payload);
  },
  replaceTemporaryOrders(state, payload) {
    state.placedOrder = payload;
  },
  noMoreNoticeModal(state) {
    state.noticeModalVisible7 = false;
  },
  noMoreNoticeModal2(state) {
    state.noticeModalVisible10 = false;
  },
  urgentWeatherModal(state, payload) {
    state.urgentWeatherModal = payload;
  },
  popupModalSwitch(state, payload) {
    state.popupPayload = payload;
  },
  updateCompleteOrder(state, payload) {
    state.completeOrder = payload;
  },
};
